import { Folder } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/** Shows which section a task lives in (e.g. "Backend › Auth") — used in the
 *  project view, where tasks are grouped by project and their section is the
 *  useful context. Empty path reads as "Unsorted". */
export function SectionPathChip({ path, className }: { path: string[]; className?: string }) {
  const label = path.length > 0 ? path.join(' › ') : 'Unsorted';
  return (
    <Badge
      variant="outline"
      className={cn('flex-shrink-0 gap-1 px-1.5 py-0 text-[10px] text-muted-foreground', className)}
      title={`Section: ${label}`}
    >
      <Folder className="h-2.5 w-2.5 flex-shrink-0" />
      <span className="max-w-[12rem] truncate">{label}</span>
    </Badge>
  );
}
